module.exports = __webpack_public_path__ + "static/media/trunk.53ce2b7f.jpg";